import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { HotelDescription } from '../../../../components/HotelDescription/index.js';
import { HotelServices } from '../../../../components/HotelServices/index.js';
import { TourOperatorInfo } from '../../../../components/TourOperatorInfo/index.js';
import { Container } from '../../../../components/TravelDetailsOverlay/components/TravelDetails/components/Container.js';
import { PaymentOptions } from '../../../../components/TravelDetailsOverlay/components/TravelDetails/components/PaymentOptions.js';
export const TravelDetails = ({
  journey
}) => {
  const {
    travelType,
    services,
    payments,
    hotel,
    tourOperator,
    tourOperatorData,
    organizerNote
  } = journey;
  const tourOperatorName = tourOperator?.name ?? '';
  const tourOperatorLogo = tourOperator?.logo ?? '';
  return _jsxs(Container, {
    children: [_jsx(HotelServices, {
      services: {
        ...services,
        travelType
      }
    }), _jsx(TourOperatorInfo, {
      organizerName: tourOperatorName,
      organizerLogo: tourOperatorLogo,
      organizerNote: organizerNote
    }), _jsx(PaymentOptions, {
      payments: payments
    }), _jsx(HotelDescription, {
      organizerName: tourOperatorName,
      organizerLogo: tourOperatorLogo,
      hotel: hotel,
      tourOperatorData: tourOperatorData
    })]
  });
};